import React from "react";
import {
  Box,
  IconButton,
  useClipboard,
  useToast,
  useColorModeValue,
} from "@chakra-ui/react";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import {
  tomorrow,
  oneLight,
} from "react-syntax-highlighter/dist/esm/styles/prism";
import { CheckIcon, CopyIcon } from "@chakra-ui/icons";
import { useTranslation } from "react-i18next";

interface CodeBlockProps {
  language?: string;
  value: string;
}

export const CodeBlock: React.FC<CodeBlockProps> = ({ language, value }) => {
  const { hasCopied, onCopy } = useClipboard(value);
  const toast = useToast();
  const codeTheme = useColorModeValue(oneLight, tomorrow);
  const { t } = useTranslation();

  const handleCopy = () => {
    onCopy();
    toast({
      title: t("chat.codeCopied"),
      status: "success",
      duration: 1000,
      isClosable: true,
    });
  };

  return (
    <Box position="relative" w="full">
      <IconButton
        aria-label={t("chat.copyCode")}
        icon={hasCopied ? <CheckIcon /> : <CopyIcon />}
        size="sm"
        position="absolute"
        top={2}
        right={2}
        onClick={handleCopy}
      />
      <SyntaxHighlighter
        language={language || "text"}
        style={codeTheme}
        customStyle={{
          margin: 0,
          borderRadius: "6px",
          paddingTop: "2.5rem",
        }}
      >
        {value}
      </SyntaxHighlighter>
    </Box>
  );
};
